import { render, staticRenderFns } from "./YearGroupRow.vue?vue&type=template&id=671e43a1"
import script from "./YearGroupRow.vue?vue&type=script&lang=js"
export * from "./YearGroupRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports